
export const capitalizeFirstLetter = ( string ) => {
    
    return string.charAt( 0 ).toUpperCase() + string.slice( 1 );
}

export const slugify = str => {

    return str.replace( /\s/g, '-' ).toLowerCase();
}

export const degreesToRadians = ( degrees ) => {

  return degrees * ( Math.PI / 180 );
}

export const getCookie = function( name ){

    let cookieValue = null;

    if( document.cookie && document.cookie !== '' ){

        const cookies = document.cookie.split( ';' );

        for ( let i = 0; i < cookies.length; i++ ) {

            const cookie = cookies[ i ].trim();

            if ( cookie.substring( 0, name.length + 1 ) === ( name + '=' ) ) {
                
                cookieValue = decodeURIComponent( cookie.substring( name.length + 1 ) );

                break;
            }
        }
    }
    
    return cookieValue;
}

export const hexToRgb = hex => {

    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec( hex );

    return result ? [
      parseInt( result[ 1 ], 16 ),
      parseInt( result[ 2 ], 16 ),
      parseInt( result[ 3 ], 16 )
    ] : null;
}

export const downloadFile = ( url, fileName ) => {

    const linkSource = `${ url }`;

    const downloadLink = document.createElement( 'a' );

    document.body.appendChild( downloadLink );

    downloadLink.href = linkSource;

    downloadLink.target = '_self';

    downloadLink.download = fileName;

    downloadLink.click(); 
}

export const srgbToLinear = ( c ) => {

    var v = 0.0;

    if( c < 0.04045 ) {

        if( c >= 0.0 ) v = c * ( 1.0 / 12.92 );
    } else {

        v = Math.pow( ( c + 0.055 ) * ( 1.0 / 1.055 ), 2.4 );
    }

    return v;
}



